import { camelCase, pascalCase } from '../helpers';
import { normalizeRelations, resolveRelations } from './helpers';

// Some modules have data that does not need to go in relations
// Ex. tabs have no resource id and return [label, notes] which
// are not needed to be stored separately
const excluded = [
  'fields',
  'items',
  'label',
  'media',
  'notes',
  'sorted',
  'perks',
  'value',
  'video'
];

const state = () => ({
  byId: {},
  allIds: []
});

const getters = {
  find: (state, _, __, rootGetters) => id => {
    const module = state.byId[id];
    if (!module) return null;

    return resolveRelations(
      module,
      Object.keys(module.data || {}).filter(
        key => !excluded.includes(key)
      ),
      rootGetters,
      { inData: true }
    );
  }
};

const actions = {
  async addModule({ commit, dispatch }, module) {
    module.type = pascalCase(module.type);

    // Data fields
    const fields = Object.keys(module.data).filter(
      key => !excluded.includes(key)
    );

    // Save module data by field (media, venues, categories etc.)
    // Run in parallel — sequential await was blocking navigation for large venue payloads.
    await Promise.all(
      fields.map(field => {
        const moduleAddPath = `${camelCase(field)}/add${pascalCase(field)}`;
        return dispatch(moduleAddPath, module.data[field], { root: true });
      })
    );

    // Save module with relationships
    commit('add', normalizeRelations(module, fields, true));
  }
}

const mutations = {
  add(state, module) {
    const existing = state.byId[module.id] || {};

    state.byId[module.id] = {
      ...existing,
      ...module,
      opacity: 1
    };

    if (!state.allIds.includes(module.id)) {
      state.allIds.push(module.id);
    }

    // Special handling for ImageShowcase for deal, venue and product pages (first module
    // after info) depending on sort order possibly being 0 based.
    if (
      module.type === 'ImageShowcase' &&
      ['deal', 'venue', 'product'].includes(module.assignment) &&
      [1, 2].includes(module.sort_order)
    ) {
      state.byId[module.id].isFixed = true;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
